module.exports = __webpack_public_path__ + "static/ma-6-sq-ffbeb0aa461b3708d21ea814c71d2f3a.png";